// Consent-gated analytics loader

const GA_MEASUREMENT_ID = 'G-S964VL5MS0';
const YM_COUNTER_ID = '47543794';

function getConsent() {
  try {
    const raw = window.localStorage.getItem('cookieConsent');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

function loadScript(src, { async = true, defer = true, id } = {}) {
  if (id && document.getElementById(id)) return;
  const script = document.createElement('script');
  script.src = src;
  if (id) script.id = id;
  if (async) script.async = true;
  if (defer) script.defer = true;
  document.head.appendChild(script);
}

function initGtag() {
  if (window.dataLayer) return; // already initialized
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
  loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`, { id: 'ga-loader', async: true, defer: true });
}

function initYandexMetrika() {
  if (!window.ym) {
    window.ym = function() { (window.ym.a = window.ym.a || []).push(arguments); };
    window.ym.l = 1 * new Date();
    loadScript('https://mc.yandex.ru/metrika/tag.js', { id: 'ym-loader' });
  }
  window.ym(YM_COUNTER_ID, 'init', {
    defer: true,
    webvisor: true,
    trackHash: true
  });
}

function onClientEntry() {
  if (typeof window === 'undefined') return;
  const consent = getConsent();
  if (consent && consent.necessary === true && consent.targeting === true) {
    initGtag();
    initYandexMetrika();
  }
}

function wrapRootElement({ element }) {
  // No-op wrapper; analytics is handled in onClientEntry based on consent
  return element;
}

// Helper to allow in-app trigger after Accept in banner without full reload
function enableAnalyticsIfConsented() {
  const consent = getConsent();
  if (consent && consent.necessary === true && consent.targeting === true) {
    initGtag();
    initYandexMetrika();
  }
}

if (typeof window !== 'undefined') {
  // expose helper for in-app calls (e.g., after Accept in banner)
  window.enableAnalyticsIfConsented = enableAnalyticsIfConsented;
}

exports.onClientEntry = onClientEntry;
exports.wrapRootElement = wrapRootElement;
exports.enableAnalyticsIfConsented = enableAnalyticsIfConsented;


